import { compose } from "recompose";

import { cartProductRemove } from "../../../../hoc/persister";
import { IProductRemove } from "../../../../hoc/persister/cartProductRemove/cartProductRemove";
import cartProductUpdate from "../../../../hoc/persister/cartProductUpdate";
import { ICartProductUpdate } from "../../../../hoc/persister/cartProductUpdate/cartProductUpdate";

import OrderRecapBody, { IProps } from "./OrderRecapBody.component";

export type IConnectedProps = ICartProductUpdate & IProductRemove;

type IContainerProps = Omit<IProps, keyof IConnectedProps>;

export default compose<IProps, IContainerProps>(
  cartProductUpdate,
  cartProductRemove
)(OrderRecapBody);
